<template>
    <span
        class="inline-flex items-center rounded-full text-xs px-3 py-1 uppercase font-semibold relative"
        :class="typeClass"
    >
        <slot>{{ text }}</slot>
        <TranslateText :text="trans" class="absolute -right-7"/>
    </span>
</template>

<script setup>
import { computed } from "vue";
import TranslateText from "@/components/TranslateText.vue";

const props = defineProps({
    text: String,
    trans: String,
    secondary: Boolean,
    warning: Boolean,
    info: Boolean,
    error: Boolean,
    success: Boolean,
});

const typeClass = computed(() => {
    if (props.secondary) {
        return 'bg-slate-700 text-white'
    }

    if (props.success) {
        return 'bg-green-700 text-white'
    }

    if (props.warning) {
        return '';
    }

    if (props.info) {
        return 'bg-blue-400 text-white';
    }

    if (props.error) {
        return '';
    }

    return 'bg-brand text-yellow-300'
})
</script>
